
import React from 'react';

const FileUpload = ({...props}) => (
  <svg viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg"><path d="m20.4605013 7.13312693v2.99925697s-2.2698282.010031-2.2812343 0v-2.99925697h-3.4218516s.0114061-1.99616099 0-2.00619195h3.4218516v-3.00928792h2.2812343v3.00928792h3.4218516v2.00619195zm-3.4218515 4.01238387v-3.00928789h-3.4218516v-3.00928793h-9.12493762c-1.25467892 0-2.28123439.90278638-2.28123439 2.00619195v12.03715167c0 1.1034056 1.02655547 2.006192 2.28123439 2.006192h13.68740642c1.2546789 0 2.2812343-.9027864 2.2812343-2.006192v-8.0247678zm-12.54678922 8.0247678 3.42185159-4.0123839 2.28123443 3.009288 3.4218516-4.0123839 4.5624688 5.0154798z"/></svg>
);

export default FileUpload;
